var styles = {"numberOutput":"styles_number-output__Qi--V","prefix":"styles_prefix__wRQVA","sign":"styles_sign__a2g-5","number":"styles_number__W-Utq","normalizationSuffix":"styles_normalization-suffix__-HB8m","suffix":"styles_suffix__5e1Ea"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
